import React from "react";
import "./refresh.css";

const RefreshButton = ({ handleRefresh, isRefreshing = false, title }) => {
  return (
    <button
      style={{
        backgroundColor: "#224E9911",
        border: "1px solid #224e99",
        color: "#224D99",
        borderRadius: "100%",
        padding: "6px 10px",
      }}
      onClick={() => handleRefresh()}
      title={title}
      disabled={isRefreshing}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="currentColor"
        className={`${isRefreshing ? "rotating" : ""}`}
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
        />
        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
      </svg>
    </button>
  );
};

export default RefreshButton;
